// Automatically focus on the input with the 'autofocus' attribute when a Bootstrap modal is shown

import { isHTMLElement } from "~/types/types.util"
import { cursorToEnd } from "~/helpers/input_helpers"

window.addEventListener("shown.bs.modal", (e) => {
  const modal = e.target
  if (modal && isHTMLElement(modal)) {
    const autofocusInput = modal.querySelector<HTMLInputElement>("[autofocus]")
    if (autofocusInput) {
      autofocusInput.focus()
      cursorToEnd(autofocusInput)
    }
  }
})
